export enum FileFakeId {
  cover = 'taskCover',
  avatar = 'userAvatar',
}
